var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',{staticClass:"has-text-right is-borderless",attrs:{"colspan":"8"}},[_vm._v(" Φ.Π.Α. ("+_vm._s(_vm.tax)+"%) ")]),_c('td',{staticClass:"has-text-centered"},[_c('strong',[_vm._v(_vm._s(_vm.taxes[_vm.tax])+" €")])])])}
var staticRenderFns = []

export { render, staticRenderFns }